import * as React from "react";
const SvgFiRrCupcake = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cupcake_svg__a)">
      <path
        fill="#062147"
        d="M23.679 11.409a12.06 12.06 0 0 0-8.968-7.144 2.994 2.994 0 1 0-5.422 0 12.06 12.06 0 0 0-8.965 7.144 4.04 4.04 0 0 0 .353 3.81c.356.535.836.976 1.4 1.285l.6 3.372A4.99 4.99 0 0 0 7.6 24h8.8a4.99 4.99 0 0 0 4.922-4.125l.6-3.371a4 4 0 0 0 1.4-1.284 4.04 4.04 0 0 0 .357-3.812M11.999 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7.358 17.525A3 3 0 0 1 16.4 22H7.6a3 3 0 0 1-2.954-2.475l-.371-2.08A3 3 0 0 0 8 17.22a2.99 2.99 0 0 0 4 0 2.99 2.99 0 0 0 4 0 3 3 0 0 0 3.728.225zm2.3-5.413A1.96 1.96 0 0 1 20 15a1.65 1.65 0 0 0-1.22.625 1.01 1.01 0 0 1-1.56 0 1.53 1.53 0 0 0-2.44 0 1.01 1.01 0 0 1-1.56 0 1.53 1.53 0 0 0-2.44 0 1.01 1.01 0 0 1-1.56 0 1.53 1.53 0 0 0-2.44 0 1.01 1.01 0 0 1-1.56 0A1.64 1.64 0 0 0 4 15a1.96 1.96 0 0 1-1.656-.888 2.02 2.02 0 0 1-.177-1.928c3.267-8.2 16.4-8.2 19.668 0a2.02 2.02 0 0 1-.177 1.928z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cupcake_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCupcake;
